export function insideRectCheck(x: number, y: number, target: HTMLElement): boolean {
  const rect = target.getBoundingClientRect();
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}
